import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserNotificationComponent } from './user-notification.component';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { UserNotificationService } from '@app/core/modules/user-notification/user-notification.service';

@NgModule({
  declarations: [UserNotificationComponent],
  imports: [CommonModule, MatSnackBarModule, MatIconModule],
  providers: [],
  exports: [UserNotificationComponent]
})
export class UserNotificationModule {
  static forRoot(): ModuleWithProviders<UserNotificationModule> {
    return {
      ngModule: UserNotificationModule,
      providers: [UserNotificationService]
    };
  }
}
